<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 mt-3 formborder">
  <div class="col-md-4 p-1" style="display: none">
    <span class="required-lable">Product Category :</span>
    <select name="SelectProductCategory"
            id="SelectProductCategory"
            #refSelectProductCategory="ngModel"
            disabled
            [(ngModel)]="SelectProductCategory"
            class="form-control input-text-css"
            required>
      <option value="">Select Category</option>
      <option *ngFor="let productCategory of ProductCategoryDropdown"
              [value]="productCategory.ProductCatId">
        {{ productCategory.Product_Category }}
      </option>
    </select>
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Name :</span>
    <input required
           type="text"
           #refProductName="ngModel"
           name="ProductName"
           id="ProductName"
           placeholder="Product Name"
           [(ngModel)]="ProductName"
           class="form-control input-text-css"
           disabled />
  </div>
  <div class="col-md-6 p-1">
    <span class="required-lable">Product Short Name :</span>
    <input required
           type="text"
           #refProductShortName="ngModel"
           name="ProductShortName"
           id="ProductShortName"
           disabled
           [(ngModel)]="ProductShortName"
           placeholder="Product Short Name"
           class="form-control input-text-css" />
  </div>
</div>
<form #f="ngForm"
      class="formborder mt-2"
      novalidate>

  <!-- HEADER -->
  <div class="row m-0">
    <div class="col-md-12 p-0">
      <h1 class="product-charges">Product Notification Configuration</h1>
    </div>
  </div>

  <!-- COLUMN HEADERS -->
  <div class="row m-0 p-0 font-weight-bold">
    <div class="col-md-2">Event Name</div>
    <div class="col-md-2 text-center">SMS Template</div>
    <div class="col-md-2 text-center">Mail Template</div>
    <div class="col-md-2 text-center">WhatsApp Template</div>
    <div class="col-md-1 text-center">SMS</div>
    <div class="col-md-1 text-center">Mail</div>
    
    <div class="col-md-1 text-center">WhatsApp</div>
    <div class="col-md-1"></div>
  </div>

  <!-- EVENT CONFIG ROWS -->
  <div class="row m-0 p-0"
       *ngFor="let row of EventConfigRows; let i = index">

    <!-- EVENT NAME -->
    <div class="col-md-2 pd-1">
      <select class="form-control input-text-css"
              name="EventId{{ i }}"
              id="EventId{{ i }}"
              [(ngModel)]="row.Event_Id"
              [disabled]="IsDisabled && row.Type !== 'New'"
              required
              #refEventId="ngModel"
              [ngClass]="{
              'is-invalid': f.submitted && refEventId.invalid,
              'alert-warning':
                refEventId.invalid &&
                (refEventId.dirty ||
                  refEventId.touched ||
                  refEventId.untouched)
            }">
        <option [ngValue]="null">Select Event</option>
        <option *ngFor="let ev of  getFilteredEventList(i)"
                [value]="ev.Id">
          {{ ev.EventName }}
        </option>
      </select>
    </div>

    <!-- SMS TEMPLATE -->
    <div class="col-md-2 pd-1">
      <select class="form-control input-text-css"
              name="SmsStep{{ i }}"
              id="SmsStep{{ i }}"
              [(ngModel)]="row.SMS_Step_Id"
              [disabled]="IsDisabled"
              #refSmsStep="ngModel"
              [ngClass]="{
              'is-invalid': f.submitted && refSmsStep.invalid,
              'alert-warning':
                refSmsStep.invalid &&
                (refSmsStep.dirty ||
                  refSmsStep.touched ||
                  refSmsStep.untouched)
            }"
              >
        <option value="">Select</option>
        <option *ngFor="let s of SMS_StepName_Dropdown"
                [value]="s.Id">
          {{ s.Step_Name }}
        </option>
      </select>
    </div>

    <!-- MAIL TEMPLATE -->
    <div class="col-md-2 pd-1">
      <select class="form-control input-text-css"
              id="MailTemplate{{ i }}"
              name="MailTemplate{{ i }}"
              [(ngModel)]="row.Mail_Step_Id"
              [disabled]="IsDisabled"
              #refMailTemplate="ngModel"
              [ngClass]="{
              'is-invalid': f.submitted && refMailTemplate.invalid,
              'alert-warning':
                refMailTemplate.invalid &&
                (refMailTemplate.dirty ||
                  refMailTemplate.touched ||
                  refMailTemplate.untouched)
            }"
              >
        <option value="">Select</option>
        <option *ngFor="let m of MailTemplateDropdown"
                [value]="m.Mail_Template_Id">
          {{ m.StepName }}
        </option>
      </select>
    </div>

    <!-- WHATSAPP TEMPLATE -->
    <div class="col-md-2 pd-1">
      <select class="form-control input-text-css"
              name="WaStep{{ i }}"
              id="WaStep{{ i }}"
              [(ngModel)]="row.WhatsApp_Step_Id"
              [disabled]="IsDisabled"
              #refWaStep="ngModel"
              [ngClass]="{
              'is-invalid': f.submitted && refWaStep.invalid,
              'alert-warning':
                refWaStep.invalid &&
                (refWaStep.dirty ||
                  refWaStep.touched ||
                  refWaStep.untouched)
            }">
        <option value="">Select</option>
        <option *ngFor="let w of WhatsAppStepNameDropdown"
                [value]="w.Id">
          {{ w.Template_Name }}
        </option>
      </select>
    </div>

    

    <!-- SMS ACTIVE -->
    <div class="col-md-1 pd-1 text-center">
      <mat-checkbox class="mt-1" [(ngModel)]="row.IsSMSActive"
                    name="SmsActive{{ i }}"
                    [disabled]="IsDisabled">
      </mat-checkbox>
    </div>
    <!-- MAIL ACTIVE -->
    <div class="col-md-1 pd-1 text-center">
      <mat-checkbox class="mt-1" [(ngModel)]="row.IsEmailActive"
                    name="MailActive{{ i }}"
                    [disabled]="IsDisabled">
      </mat-checkbox>
    </div>

    <!-- WHATSAPP ACTIVE -->
    <div class="col-md-1 pd-1 text-center">
      <mat-checkbox class="mt-1" [(ngModel)]="row.IsWhatsAppActive"
                    name="WaActive{{ i }}"
                    [disabled]="IsDisabled">
      </mat-checkbox>
    </div>

    <!-- ADD / REMOVE -->
    <div class="col-md-1 pd-1 text-center">
      <button type="button"
              class="remove"
              (click)="removeEventRow(i)"
              [disabled]="IsDisabled"
              *ngIf="EventConfigRows.length > 1">
        −
      </button>

      <button type="button"
              class="addmore"
              (click)="addEventRow()"
              [disabled]="IsDisabled || !canAddRow(row)"
              *ngIf="i === EventConfigRows.length - 1">
        +
      </button>
    </div>
  </div>

  <!-- ACTION BUTTONS -->
  <div class="row m-0 p-2">
    <div class="col-md-12 text-right">
      <button 
      type="button"
      class="btn font-size-12 button-btn"
      (click)="saveEventConfig()"
      *ngIf="IsSave"
      [disabled]="!f.form.valid">
       
      Save
    </button>

      <button type="button"
              class="btn font-size-12 button-btn"
              (click)="onEditConfig()"
              *ngIf="IsEdit">
        Edit
      </button>

      <button type="button"
              class="btn font-size-12 button-btn"
              (click)="onSaveNewProduct()"
              *ngIf="IsUpdate"
              [disabled]="
          !f.form.valid
        ">
        Update
      </button>

    </div>
  </div>

</form>

